<template>
  <div class="single-payment">
    <div class="container">
      <div class="single-payment__head">
        <h4>Hola {{ showUserName() }}</h4>
        <div class="single-payment__head__back">
          <a @click="back">
            <img :src="require('@/assets/images/app/chevron.svg')" alt="" />
          </a>
          <span>Realizar pago de mi cuota</span>
        </div>
      </div>
      <div class="single-payment__body">
        <div class="payment-card">
          <span class="payment-card__title">Aceptamos todas las tarjetas:</span>
          <div class="payment-card__img">
            <img :src="require('@/assets/images/app/card-brands.png')" alt="" />
          </div>
          <form action="">
            <div
              class="form-group w-icon"
              :class="{ invalid: this.v$.payment.creditCardNumber.$error }"
            >
              <img
                :src="require('@/assets/images/app/Trazado14308.svg')"
                :class="{ show: this.payment.creditCardType == '' }"
                alt=""
                class="card-img"
              />
              <img
                :src="require('@/assets/images/app/visa.svg')"
                :class="{ show: this.payment.creditCardType === 'VISA' }"
                alt=""
                class="card-img"
              />
              <img
                :src="require('@/assets/images/app/mc.svg')"
                :class="{ show: this.payment.creditCardType === 'MASTERCARD' }"
                alt=""
                class="card-img"
              />
              <img
                :src="require('@/assets/images/app/diners.svg')"
                :class="{ show: this.payment.creditCardType === 'DINERS' }"
                alt=""
                class="card-img"
              />
              <img
                :src="require('@/assets/images/app/amex.svg')"
                alt=""
                class="card-img"
                :class="{ show: this.payment.creditCardType === 'AMEX' }"
              />
              <!---->
              <input
                type="text"
                class="form-control"
                placeholder="Número de tarjeta"
                data-culqi="card[number]"
                id="card[number]"
                v-mask="'#### #### #### ####'"
                v-model="this.v$.payment.creditCardNumber.$model"
                @keyup="validateCreditCard()"
              />
              <!---->
              <span>Por favor ingresa el n&uacute;mero de tu tarjeta</span>
              <img
                :src="require('@/assets/images/app/check-color.svg')"
                class="valid-card-img"
                :class="{ show: this.payment.validCard }"
                alt=""
              />
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="form-group w-icon"
                  :class="{
                    invalid:
                      this.v$.payment.expirationDate.$error
                      | this.flags.invalidExpirationDate,
                  }"
                >
                  <img
                    :src="require('@/assets/images/app/img1.svg')"
                    class="card-img show exp"
                    alt=""
                  />
                  <input
                    type="text"
                    class="form-control"
                    placeholder="MM/AA"
                    maxlength="5"
                    v-model="this.v$.payment.expirationDate.$model"
                    v-mask="'##/##'"
                    @change="setExpirationDate()"
                    @keydown="validateInput($event, /^\d+$/)"
                  />
                  <span
                    >Por favor ingresa una fecha de expiraci&oacute;n
                    v&aacute;lida</span
                  >
                  <input
                    type="hidden"
                    size="2"
                    v-model="this.v$.payment.month.$model"
                    data-culqi="card[exp_month]"
                    id="card[exp_month]"
                  />
                  <input
                    type="hidden"
                    size="4"
                    v-model="this.v$.payment.year.$model"
                    data-culqi="card[exp_year]"
                    id="card[exp_year]"
                  />
                </div>
              </div>
              <div class="col">
                <div
                  class="form-group w-icon"
                  :class="{ invalid: this.v$.payment.maskedCvv.$error }"
                >
                  <img
                    :src="require('@/assets/images/app/lock.svg')"
                    alt=""
                    class="card-img show cvv"
                  />
                  <input
                    type="text"
                    class="form-control"
                    placeholder="CVV"
                    maxlength="4"
                    v-model="this.v$.payment.maskedCvv.$model"
                    @change="maskCvv()"
                    @keydown="validateInput($event, /^\d+$/)"
                  />
                  <span>Por favor ingresa el c&oacute;digo CVV</span>
                  <input
                    type="hidden"
                    size="4"
                    v-model="this.v$.payment.cvv.$model"
                    data-culqi="card[cvv]"
                    id="card[cvv]"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm">
                <div
                  class="form-group"
                  :class="{ invalid: this.v$.payment.placeholder.$error }"
                >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Nombre"
                    @keypress="
                      validateInput(
                        $event,
                        /^[ñA-Za-z _\s]*[ñA-Za-z\s][ñA-Za-z _\s]*$/
                      )
                    "
                    v-model="this.v$.payment.placeholder.$model"
                  />
                  <span>Por favor ingresa el titular de la tarjeta</span>
                  <input
                    type="hidden"
                    class="form-control"
                    v-model="this.v$.payment.email.$model"
                    data-culqi="card[email]"
                    id="card[email]"
                  />
                </div>
              </div>
              <div class="col-sm">
                <div
                  class="form-group"
                  :class="{ invalid: this.v$.payment.email.$error }"
                >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Correo electrónico"
                    v-model="this.v$.payment.email.$model"
                    data-culqi="card[email]"
                    id="card[email]"
                  />
                  <span>Por favor ingresa tu correo electrónico</span>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <button
                type="button"
                class="payment-card__btn"
                @click="change()"
                :disabled="flags.paying"
              >
                <span v-if="!flags.paying">Pagar</span>
                <i class="fas fa-circle-notch fa-spin" v-if="flags.paying"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-ZoneApport"
      ok-only
      ok-title="Entendido"
      centered
      size="sm"
      modal-class="change-payment__modal-ZoneApport"
      ref="modal-zone-client"
    >
      <form class="additional-aport">
        <div class="additional-aport__txt">
          <span>¡Tarjeta Actualizada!</span>
          <span
            >A partir de hoy tus aportes serán debitados de esta tarjeta.</span
          >
        </div>
        <div class="additional-aport__btn">
          <button
            type="button"
            class="accept"
            @click="closeModal('modal-zone-client')"
          >
            Aceptar
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="modal-error"
      ok-only
      ok-title="Entiendo"
      centered
      modal-class="modal-error"
      ref="modal-card-error"
    >
      <div class="modal-error__header">
        <div class="modal-error__header__message">
          <span>Error</span>
        </div>
        <div class="modal-error__img">
          <img :src="require('@/assets/images/app/error.svg')" alt="" />
        </div>
      </div>
      <div class="modal-error__head">
        <span
          >Por favor ingrese una tarjeta de cr&eacute;dito o d&eacute;bito
          v&aacute;lida</span
        >
        <div class="modal-error__head__btn">
          <button
            type="button"
            class="accept"
            @click="closeModal('modal-card-error')"
          >
            Entendido
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-error"
      ok-only
      ok-title="Entiendo"
      centered
      modal-class="modal-error"
      ref="modal-error"
    >
      <div class="modal-error__header">
        <div class="modal-error__header__message">
          <span>Error</span>
        </div>
        <div class="modal-error__img">
          <img :src="require('@/assets/images/app/error.svg')" alt="" />
        </div>
      </div>
      <div class="modal-error__head">
        <span v-if="errors.payment === ''">
          Se ha presentado un error en nuestro sistema. Intenta nuevamente o
          escríbenos a correo rumbo@interseguro.com.pe
        </span>
        <span v-if="errors.payment !== ''">
          {{ errors.payment }}
        </span>
        <div class="modal-error__head__btn">
          <button
            type="button"
            class="accept"
            @click="closeModal('modal-error')"
          >
            Entendido
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-success"
      ok-only
      ok-title="Entiendo"
      centered
      modal-class="modal-success"
      ref="modal-success"
    >
      <div class="modal-success__header">
        <div class="modal-success__header__message">
          <span>Enviado</span>
        </div>
        <div class="modal-success__img">
          <img :src="require('@/assets/images/app/checks.svg')" alt="" />
        </div>
      </div>

      <div class="modal-success__head">
        <div class="modal-success__head__content">
          <span class="evaluate" style="font-size: 14px; !important"
            >Tu pago fue realizado con &eacute;xito.</span
          >
        </div>
        <div class="modal-success__head__btn">
          <button
            type="button"
            class="accept"
            @click="closeModal('modal-success')"
          >
            Entendido
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
  
<script lang="ts">
import { BButton, BModal, VBModal, BCardText } from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import es from "vuejs-datepicker/dist/locale/translations/es";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import { mask, field, VueTheMask } from "vue-the-mask";
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";
import axios from "axios";
import valid from "card-validator";
import moment from "moment";
import { environment } from "../../../../environment/environment";
import { defineComponent } from "vue";
import useVuelidate from "@vuelidate/core";

declare const Culqi: any;

export default defineComponent({
  components: {
    Datepicker,
    BCardText,
    VueSlider,
    BModal,
    VBModal,
  },
  directives: { mask },
  data() {
    return {
      basePath: window["basePath"],
      apiUrl: environment.api,
      v$: useVuelidate(),
      policyId: "",
      planName: "",
      amount: 0,
      payment: {
        creditCardNumber: "",
        creditCardType: "",
        validCard: false,
        placeholder: "",
        expirationDate: "",
        year: "",
        month: "",
        maskedCvv: "",
        cvv: "",
        invoice: false,
        email: "",
      },
      flags: {
        invalidCard: false,
        paymentCompleted: false,
        disabledInputs: true,
        olderThanAllowedAge: false,
        validateOtp: false,
        logingIn: false,
        paying: false,
      },
      es: es,
      disabledDates: null,
      marketingEmails: false,
      automaticDebit: true,
      otp: null,
      terms: false,
      paymentMethod: null,
      errors: {
        terms: false,
        payment: "",
      },
    };
  },
  validations: function () {
    return {
      payment: {
        creditCardNumber: { required },
        creditCardType: {},
        installments: {},
        placeholder: { required },
        expirationDate: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(5),
        },
        year: {},
        month: {},
        maskedCvv: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(4),
        },
        cvv: {},
        email: { required, email },
      },
    };
  },
  created() {
    this.init();
  },
  watch: {},
  methods: {
    init() {
      this.initCulqui();
      this.getPolicyId();
      this.getFund();
      this.getPyamentMethods();
    },
    showUserName() {
      let user: any = window.localStorage.getItem("__user__");
      if (user) {
        user = JSON.parse(user);

        return user.firstName;
      }

      return "";
    },
    back() {
      this.$router.push({
        name: "policies",
        query: { open: this.policyId },
      });
    },
    initCulqui() {
      Culqi.publicKey = environment.culquiToken;
      Culqi.init();
    },
    getPolicyId() {
      const urlParams = new URLSearchParams(window.location.search);
      const policyId = this.$route.params.id;

      this.policyId = policyId;
    },
    getFund() {
      let fund: any = window.localStorage.getItem("__selectedFund__");

      fund = JSON.parse(fund);
      this.planName = fund.name;
      this.amount = fund.paymentAmount;
    },
    async getPyamentMethods() {
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };
      let result = await axios.get(`${this.apiUrl}paymentMethods`, headers);

      if (result.data) {
        this.paymentMethod = result.data ? result.data[0] : null;
      }
    },
    validateCreditCard() {
      let _context = this;
      let card = valid.number(this.payment.creditCardNumber);
      let cards = {
        visa: "VISA",
        "american-express": "AMEX",
        "diners-club": "DINERS",
        mastercard: "MASTERCARD",
      };
      this.payment.validCard = card.isValid;

      if (this.payment.validCard) this.flags.invalidCard = false;

      if (card.card) {
        this.payment.creditCardType = cards[card.card.type];
      } else {
        this.payment.creditCardType = "";
      }
    },
    validateExpirationDate(event) {
      if (event.keyCode === 8) return;

      let expDate = this.payment.expirationDate;

      if (expDate.length === 2) {
        this.payment.expirationDate = expDate + "/";
      }
    },
    setExpirationDate() {
      if (this.payment.expirationDate.length !== 5) {
        return;
      }

      let currYear = new Date().getFullYear();
      let currMonth = new Date().getMonth() + 1;

      let expDate = this.payment.expirationDate.split("/");
      let month: any = parseInt(expDate[0]);
      let year = parseInt(expDate[1]) + 2000;

      if (new Date(year, month) < new Date(currYear, currMonth)) {
        this.flags.invalidExpirationDate = true;
        return;
      } else {
        this.flags.invalidExpirationDate = false;
      }

      if (month < 10) month = "0" + month;
      else month = month.toString();

      this.payment.month = month;
      this.payment.year = year;
    },
    validateInput(event, regex) {
      let key = event.key;
      let allowedKeys = [8, 9, 13];

      if (!regex.test(key) && allowedKeys.indexOf(event.keyCode) < 0)
        event.preventDefault();
    },
    maskCvv() {
      let _context = this;

      this.payment.cvv = this.payment.maskedCvv;

      setTimeout(function () {
        _context.payment.maskedCvv = _context.payment.maskedCvv.replace(
          /./g,
          "*"
        );
      }, 3000);
    },
    async change() {
      if (!this.payment.validCard) {
        this.$refs["modal-card-error"].show();
        return;
      }
      window.localStorage.removeItem("__culquiToken__");
      let _context = this;

      if (this.v$.payment.$invalid) {
        this.v$.payment.$touch();
        return;
      }

      this.flags.paying = true;
      Culqi.createToken();

      var checkToken = setInterval(async () => {
        let token = JSON.parse(window.localStorage.getItem("__culquiToken__"));
        if (token) {
          clearInterval(checkToken);
        }

        if (token && token.id) {
          let model = {
            id: this.policyId,
            payment: {
              placeholder: _context.payment.placeholder,
              creditCardTokenId: token.id,
              cardNumber: token.card_number,
              frecuency: 0,
              debitAutomatic: false,
              amount: _context.amount,
              currency: "PEN",
              billingEmail: _context.payment.email,
            },
          };

          try {
            let auth = JSON.parse(window.localStorage.getItem("__auth__"));
            let headers = {
              headers: {
                Authorization: auth.token_type + " " + auth.access_token,
              },
            };
            var result = await axios.post(
              `${_context.apiUrl}policies/${this.policyId}/single-payment`,
              model,
              headers
            );

            if (result.data) {
              this.saveDataLayerEvent({
                event: "virtualEvent",
                category: "Rumbo - Mis fondos",
                action: "Seleccionar - Aporte adicional - Pagar",
                label: _context.payment.amount,
              });
            }

            this.flags.paying = false;
            this.$refs["modal-success"].show();
          } catch (error) {
            this.$refs["modal-error"].show();
            this.flags.paying = false;
          }
        } else {
          if (token && token.user_message) {
            this.errors.payment = token.user_message;
            this.$refs["modal-error"].show();
            this.flags.paying = false;
          }
        }
      }, 500);
    },
    editFields() {
      this.flags.disabledInputs = !this.flags.disabledInputs;
    },
    validateDob() {
      var date = moment();
      var dob = moment(this.userInfo.dateOfBirth);

      var diff = date.diff(dob, "years");
      console.log(diff);
      if (diff > 60) {
        this.flags.olderThanAllowedAge = true;
      }
    },
    changeAmount() {
      this.loadOptions();
    },
    goHome() {
      window.location.href = "/";
    },
    async sendOtp() {
      if (this.v$.login.$invalid) {
        this.v$.login.$touch();
        return;
      }

      this.saveDataLayerEvent({
        event: "login",
        userid: this.login.identificationNumber,
      });

      this.flags.logingIn = true;

      let model = {
        identificationType: this.login.identificationType,
        identificationNumber: this.login.identificationNumber,
      };

      var result = await axios.post(
        `${this.apiUrl}sign-in/otp/generate`,
        model
      );

      if (result.data) {
        this.flags.validateOtp = true;
        this.flags.logingIn = false;

        this.otp = result.data;
      }
    },
    async validateOtp() {
      if (this.v$.otpCode.$invalid) {
        this.v$.otpCode.$touch();
        return;
      }

      this.flags.logingIn = true;

      let model = {
        identificationType: this.login.identificationType,
        identificationNumber: this.login.identificationNumber,
        code: this.otpCode.code,
        otpId: this.otp.otpId,
      };

      var result = await axios.post(
        `${this.apiUrl}sign-in/otp/validate`,
        model
      );

      if (result.data) {
        window.localStorage.setItem("__auth__", JSON.stringify(result.data));
        window.location.href = "/funds/all";
      } else {
        this.flags.logingIn = false;
      }
    },
    formatNumber(x) {
      return x;
    },
    saveDataLayerEvent(event) {
      if (window["dataLayer"]) {
        window["dataLayer"].push(event);
      }
    },
    goBack() {
      window.location.href = "/funds/all";
    },
    closeModal(modal) {
      this.$refs[modal].hide();
      // window.location.href = this.basePath + "/funds/all";
    },
  },
});
</script>
  
<style lang="scss">
/**/
@import "../../../../styles/abstracts/variables";
/**/
/*
    MOB
*/

.hidden-mobile {
  @media (max-width: $mobileBreak) {
    display: none !important;
  }
}

.visible-mobile {
  @media (min-width: $desktopBreak) {
    display: none !important;
  }
}

.single-payment {
  padding: 30px 0px 0px 90px;
  background-color: #f1f4f9;
  height: 100vh;

  @media (max-width: $mobileBreak) {
    padding: 20px 0px 10px 0px;

    .container {
      padding: 0 !important;
    }
  }

  &__head {
    margin-bottom: 20px;
    h4 {
      font-family: $firstFont;
      font-size: 25px;
      color: $fourthGray;

      @media (max-width: $mobileBreak) {
        font-size: 15px;
      }
    }

    &__back {
      display: flex;
      align-items: center;

      a {
        cursor: pointer;
      }

      span {
        font-family: $firstFont;
        font-weight: 600;
        font-size: 24px;
        color: $primaryBlue;
        margin: 0px 0px 0px 25px;

        @media (max-width: $mobileBreak) {
          font-size: 15px;
        }
      }

      @media (max-width: $mobileBreak) {
        img {
          width: 10px;
        }
      }
    }
  }

  &__body {
    display: flex;
    justify-content: center;
    margin: 80px 0px 0px 0px;
    width: 100%;

    @media (max-width: $mobileBreak) {
      margin: 10px 0px 0px 0px;
    }

    .payment-card {
      border-radius: 25px;
      width: 430px;
      background-color: white;
      box-shadow: 0px 1px 8px rgba($color: #000000, $alpha: 0.1);
      padding: 20px;

      @media (max-width: $mobileBreak) {
        padding: 20px 15px 30px 15px;
        width: 100%;
      }

      &__title {
        font-family: $firstFont;
        font-size: 15px;
        color: $primaryGray;
        display: block;
        padding: 15px;
        text-align: center;
      }

      &__img {
        display: flex;
        justify-content: center;
        margin: 0px 0px 15px 0px;

        img {
          width: 250px;
        }
      }

      form {
        .form-group {
          margin-bottom: 10px;

          span {
            display: none;
            font-size: 14px;
            font-weight: 600;
            margin: 0px 0px 0px 0px;
            color: $primaryRed;
          }

          &.invalid {
            span {
              display: block;
            }
          }

          &.w-icon {
            position: relative;

            .form-control {
              padding-left: 40px;
              margin-bottom: 0;
            }

            .card-img {
              position: absolute;
              top: 12px;
              left: 8px;
              width: 25px;
              opacity: 0;
              visibility: collapse;
              transition: 0.3s;

              &.show {
                z-index: 1;
                opacity: 1;
                visibility: visible;
              }

              &.exp {
                width: 20px;
                top: 10px;
                left: 10px;
              }

              &.cvv {
                top: 9px;
                left: 10px;
                width: 20px;
              }
            }

            .valid-card-img {
              position: absolute;
              top: 10px;
              right: 10px;
              opacity: 0;
              transition: 0.3s;

              &.show {
                opacity: 1;
              }
            }
          }

          .form-control {
            font-size: 15px;
            color: $primaryGray;

            &::placeholder {
              font-size: 15px;
              color: $secondGray;
              transition: 0.3s;
            }

            &:focus {
              box-shadow: none;
              border: 1px solid $primaryBlue;
              box-shadow: 0px 1px 8px rgba($color: #000000, $alpha: 0.1);
            }

            &:focus::placeholder {
              padding-left: 5px;
            }
          }
        }
      }

      &__btn {
        font-family: $firstFont;
        font-weight: 500;
        font-size: 18px;
        width: 50%;
        height: 45px;
        color: white;
        border: none;
        margin: 25px 0px 0px 0px;
        border-radius: 5px;
        background-color: $primaryPink;
        box-shadow: 0px 1px 8px rgba($color: #000000, $alpha: 0.2);
      }
    }
  }
}
</style>